'use no memo';

import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { GripVertical } from 'lucide-react';

import type { ReactNode } from 'react';

import { TableCell, TableRow } from '@/components/ui/table';

type DraggableRowProps = {
  id: string;
  className?: string;
  children: ReactNode;
};

export const DraggableRow = (props: DraggableRowProps) => {
  const { id, className, children } = props;
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({ id, animateLayoutChanges: () => false });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isDragging ? 0.5 : undefined,
  };

  return (
    <TableRow
      ref={setNodeRef}
      style={style}
      className={className}
    >
      <TableCell className="w-12">
        <button
          type="button"
          aria-label="Drag to reorder"
          className="text-muted-foreground hover:text-foreground flex cursor-grab touch-none items-center"
          {...attributes}
          {...listeners}
        >
          <GripVertical className="size-4" />
        </button>
      </TableCell>
      {children}
    </TableRow>
  );
};
